/**
 * transform bytes to kb or mb
 * @param {Bytes} size
 */
export const getFileSizeString = size => {
  if (typeof size !== 'number' || size <= 0) {
    return '0';
  }
  if (size / 1024 / 1024 >= 1) {
    // >= 1mb
    return `${parseFloat(size / 1024 / 1024).toFixed(2)}M`;
  }
  return `${parseFloat(size / 1024).toFixed(2)}kb`;
};

export default {
  getFileSizeString,
};
